(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["native-posture-bra"] && !Shopify.designMode) return;
  try {
    
function initializePosture(root){
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  const form=root.querySelector('.nb-form');
  const variants=JSON.parse(root.querySelector('[data-posture-variants]').textContent);
  const cards=Array.from(root.querySelectorAll('[data-pack-card]'));
  const error=root.querySelector('.nb-error');
  const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.Shopify.currency.active,currencyDisplay:'code'}).format(value/100);
  const colorOrder=['Black','Cream','Dark Brown Leopard','Pink Leopard'];
  const combination=colors=>[...colors].sort((a,b)=>colorOrder.indexOf(a)-colorOrder.indexOf(b)).join(' + ');
  function cardColors(card){return Array.from(card.querySelectorAll('.nb-color-field')).map(field=>field.querySelector('input:checked').value);}
  function findVariant(pack,size,colors){return variants.find(v=>v.option1===pack+' Pack'&&v.option2===size&&(pack===4?v.option3==='Choose any four colors':v.option3===combination(colors)));}
  function selection(){
    const pack=Number(form.querySelector('[name=posture_pack]:checked').value);
    const size=form.querySelector('[name=posture_size]:checked')?.value;
    const card=cards.find(c=>Number(c.dataset.packCard)===pack);
    const colors=cardColors(card);
    return {pack,size,colors,variant:findVariant(pack,size,colors)};
  }
  function update(){
    const selected=selection();
    cards.forEach(card=>{
      const pack=Number(card.dataset.packCard),colors=cardColors(card),size=selected.size||'S';
      card.querySelector('.nb-pack-colors').hidden=pack!==selected.pack;
      card.querySelectorAll('.nb-color-field').forEach(field=>field.querySelector('[data-color-name]').textContent=field.querySelector('input:checked').value);
      const variant=findVariant(pack,size,colors);
      card.querySelector('[data-pack-price]').textContent=variant?.money||'Unavailable';
      const regular=colors.reduce((sum,color)=>sum+(findVariant(1,size,[color])?.price||0),0);
      const saving=card.querySelector('[data-pack-saving]');
      saving.textContent=variant&&pack>1&&regular>variant.price?'Save '+Math.round((regular-variant.price)*100/regular)+'% compared with buying individually':'';
    });
    root.querySelector('[data-size-name]').textContent=selected.size||'';
    const display=selected.variant||findVariant(selected.pack,'S',selected.colors);
    root.querySelector('[data-posture-total]').textContent=display?.money||'';
    form.querySelector('[name=id]').value=selected.variant?.id||'';
    if(selected.size)root.querySelector('[data-posture-selection]').textContent=selected.pack+' '+(selected.pack===1?'bra':'bras')+' · Size '+selected.size+' · '+selected.colors.join(' / ');
    error.hidden=true;
  }
  cards.forEach(card=>card.addEventListener('click',event=>{
    if(event.target.closest('input,label,button,a,select,textarea'))return;
    const radio=card.querySelector('input[name=posture_pack]');
    if(!radio.checked)radio.click();
  }));
  form.addEventListener('change',update);
  form.addEventListener('submit',async event=>{
    event.preventDefault();event.stopImmediatePropagation();
    const selected=selection();
    if(!selected.size||!selected.variant){error.textContent='Choose your size before adding your pack.';error.hidden=false;form.querySelector('[name=posture_size]').focus();return;}
    const button=form.querySelector('[type=submit]');
    if(button.disabled)return;
    const properties={};selected.colors.forEach((color,i)=>properties['Bra '+(i+1)]=color+' / '+selected.size);
    const drawer=document.querySelector('cart-drawer');
    const items=[{id:selected.variant.id,quantity:1,properties}];
    button.disabled=true;button.setAttribute('aria-busy','true');error.hidden=true;
    try{
const vipConfig=JSON.parse(root.querySelector('[data-native-vip-config]').textContent);
      if(!vipConfig.variantId||!vipConfig.sellingPlanId)throw new Error('VIP enrollment is temporarily unavailable. Please try again shortly.');
      const cartResponse=await fetch(window.Shopify.routes.root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
      if(!cartResponse.ok)throw new Error('We could not verify your cart. Please try again.');
      const cart=await cartResponse.json();
      const trialLines=cart.items.filter(item=>Number(item.variant_id)===Number(vipConfig.variantId));
      if(trialLines.some(item=>Number(item.selling_plan_allocation?.selling_plan?.id)!==Number(vipConfig.sellingPlanId)))throw new Error('Remove the existing VIP membership from your cart, then try again to start the free trial.');
      if(!trialLines.length)items.push({id:vipConfig.variantId,quantity:1,selling_plan:vipConfig.sellingPlanId});
      const payload={items};
      if(drawer?.getSectionsToRender&&drawer?.renderContents){payload.sections=drawer.getSectionsToRender().map(s=>s.id);payload.sections_url=window.location.pathname;drawer.setActiveElement?.(button);}
      const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
      const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||'We could not add your pack. Please try again.');
      if(drawer?.renderContents&&payload.sections){drawer.classList.remove('is-empty');drawer.renderContents(result);}else window.location.assign(window.Shopify.routes.root+'cart');
    }catch(e){error.textContent=e.message;error.hidden=false;}finally{button.disabled=false;button.removeAttribute('aria-busy');}
  },true);
  const outfitTrack=root.querySelector('[data-outfit-track]');if(outfitTrack){const outfitCards=Array.from(outfitTrack.querySelectorAll('article'));const outfitButtons=Array.from(root.querySelectorAll('[data-outfit-direction]'));const outfitCounter=root.querySelector('[data-outfit-count]');const position=card=>card.getBoundingClientRect().left-outfitTrack.getBoundingClientRect().left+outfitTrack.scrollLeft;const current=()=>outfitCards.reduce((best,card,i)=>Math.abs(position(card)-outfitTrack.scrollLeft)<Math.abs(position(outfitCards[best])-outfitTrack.scrollLeft)?i:best,0);const refresh=()=>{const max=outfitTrack.scrollWidth-outfitTrack.clientWidth;outfitButtons.forEach(button=>button.disabled=Number(button.dataset.outfitDirection)<0?outfitTrack.scrollLeft<=2:outfitTrack.scrollLeft>=max-2);outfitCounter.textContent=(current()+1)+' / '+outfitCards.length;};outfitButtons.forEach(button=>button.addEventListener('click',()=>{const next=Math.max(0,Math.min(outfitCards.length-1,current()+Number(button.dataset.outfitDirection)));outfitTrack.scrollTo({left:position(outfitCards[next]),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));outfitTrack.addEventListener('scroll',refresh,{passive:true});new ResizeObserver(refresh).observe(outfitTrack);refresh();}
  const detailTrack=root.querySelector('[data-detail-track]');
  if(detailTrack){
    const detailCards=Array.from(detailTrack.querySelectorAll('article'));
    const detailButtons=Array.from(root.querySelectorAll('[data-detail-direction]'));
    const detailCount=root.querySelector('[data-detail-count]');
    const position=card=>card.getBoundingClientRect().left-detailTrack.getBoundingClientRect().left+detailTrack.scrollLeft;
    const detailIndex=()=>detailCards.reduce((best,card,i)=>Math.abs(position(card)-detailTrack.scrollLeft)<Math.abs(position(detailCards[best])-detailTrack.scrollLeft)?i:best,0);
    const updateDetails=()=>{const max=detailTrack.scrollWidth-detailTrack.clientWidth;detailButtons.forEach(button=>button.disabled=Number(button.dataset.detailDirection)<0?detailTrack.scrollLeft<=2:detailTrack.scrollLeft>=max-2);detailCount.textContent=(detailIndex()+1)+' / '+detailCards.length;};
    detailButtons.forEach(button=>button.addEventListener('click',()=>{const next=Math.max(0,Math.min(detailCards.length-1,detailIndex()+Number(button.dataset.detailDirection)));detailTrack.scrollTo({left:position(detailCards[next]),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));
    detailTrack.addEventListener('scroll',updateDetails,{passive:true});
    detailTrack.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();detailButtons.find(button=>Number(button.dataset.detailDirection)===(event.key==='ArrowLeft'?-1:1)).click();}});
    new ResizeObserver(updateDetails).observe(detailTrack);updateDetails();
  }
  const image=root.querySelector('.nb-main-image');
  const thumbs=Array.from(root.querySelectorAll('[data-posture-photo]'));
  let photoIndex=0,gesture=null,ignoreClickUntil=0;
  function showPhoto(index){if(!thumbs.length)return;photoIndex=(index+thumbs.length)%thumbs.length;image.src=thumbs[photoIndex].dataset.posturePhoto;image.alt=thumbs[photoIndex].dataset.postureColor?thumbs[photoIndex].dataset.postureColor+' Posture Correcting Bra':thumbs[photoIndex].querySelector('img').alt;image.removeAttribute('srcset');thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===photoIndex)));root.querySelector('.nb-count').textContent=(photoIndex+1)+' / '+thumbs.length;const track=root.querySelector('.nb-thumbs');const active=thumbs[photoIndex];if(track){const left=active.getBoundingClientRect().left-track.getBoundingClientRect().left+track.scrollLeft-(track.clientWidth-active.offsetWidth)/2;track.scrollTo({left:Math.max(0,left),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}}
  const colorPhotoNames={"Black":"nb-bra-black","Cream":"nb-bra-cream","Dark Brown Leopard":"nb-bra-brown-leopard","Pink Leopard":"nb-bra-pink-leopard"};
  Object.entries(colorPhotoNames).forEach(([color,name])=>{const thumb=thumbs.find(button=>button.dataset.posturePhoto.includes(name));if(thumb){thumb.dataset.postureColor=color;thumb.querySelector('img').alt=color+' Posture Correcting Bra';}});
  function previewColor(color){const index=thumbs.findIndex(button=>button.dataset.postureColor===color);if(index>=0)showPhoto(index);}
  form.addEventListener('change',event=>{if(event.target.name?.startsWith('posture_color_'))previewColor(event.target.value);else if(event.target.name==='posture_pack')previewColor(selection().colors[0]);});
  thumbs.forEach((b,i)=>b.addEventListener('click',()=>showPhoto(i)));
  root.querySelectorAll('[data-photo-direction]').forEach(b=>b.addEventListener('click',()=>showPhoto(photoIndex+Number(b.dataset.photoDirection))));
  root.querySelector('.nb-photo').addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();showPhoto(photoIndex+(event.key==='ArrowRight'?1:-1));}});
  if(image){
    image.draggable=false;
    image.addEventListener('pointerdown',e=>{if(!e.isPrimary){gesture=null;return;}if(e.pointerType==='mouse'&&e.button!==0)return;gesture={id:e.pointerId,x:e.clientX,y:e.clientY};image.setPointerCapture(e.pointerId);});
    image.addEventListener('pointerup',e=>{if(!gesture||gesture.id!==e.pointerId)return;const dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;gesture=null;if(Math.abs(dx)>=40&&Math.abs(dx)>Math.abs(dy)*1.2){ignoreClickUntil=Date.now()+400;showPhoto(photoIndex+(dx<0?1:-1));}});
    image.addEventListener('pointercancel',()=>gesture=null);
    const dialog=root.querySelector('.nb-lightbox');
    function enlarge(){dialog.querySelector('img').src=image.currentSrc;dialog.showModal();}
    image.addEventListener('click',()=>{if(Date.now()>=ignoreClickUntil)enlarge();});root.querySelector('.nb-zoom').addEventListener('click',enlarge);dialog.querySelector('button').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
  }
  const requested=variants.find(v=>String(v.id)===new URLSearchParams(window.location.search).get('variant'));
  if(requested){const pack=parseInt(requested.option1);form.querySelector('[name=posture_pack][value="'+pack+'"]').checked=true;form.querySelector('[name=posture_size][value="'+requested.option2+'"]').checked=true;if(pack!==4)requested.option3.split(' + ').forEach((color,i)=>{const input=form.querySelector('[name="posture_color_'+pack+'_'+(i+1)+'"][value="'+color+'"]');if(input)input.checked=true;});}
  update();
}
document.querySelectorAll('[data-posture-root]').forEach(initializePosture);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-posture-root]').forEach(initializePosture));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-silk-s05"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-nb-body-ticker]').forEach(bar => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      const track = bar.querySelector('.nb-body-ticker-track');
      const group = bar.querySelector('.nb-body-ticker-group');
      const button = bar.querySelector('button');
      let offset = 0, previous = 0, frame = 0, distance = 0, paused = false;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const measure = () => {
        distance = group.getBoundingClientRect().width;
        if (distance) offset %= distance;
      };
      const tick = time => {
        frame = 0;
        if (!bar.isConnected || document.hidden || paused) { previous = 0; return; }
        if (!distance) measure();
        if (previous && distance) offset = (offset + Math.min(time - previous, 64) * (reduced.matches ? 0.018 : 0.036)) % distance;
        track.style.setProperty('transform', 'translate3d(' + (-offset) + 'px,0,0)', 'important');
        previous = time;
        frame = requestAnimationFrame(tick);
      };
      const restart = () => {
        cancelAnimationFrame(frame);
        previous = 0;
        measure();
        if (!paused && !document.hidden && bar.isConnected) frame = requestAnimationFrame(tick);
      };
      button.hidden = false;
      button.addEventListener('click', () => {
        paused = !paused;
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.resume : button.dataset.pause);
        restart();
      });
      const observer = window.ResizeObserver ? new ResizeObserver(restart) : null;
      if (observer) observer.observe(group);
      window.addEventListener('resize', restart);
      window.addEventListener('pageshow', restart);
      document.addEventListener('visibilitychange', restart);
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(bar)) return;
        cancelAnimationFrame(frame);
        if (observer) observer.disconnect();
        window.removeEventListener('resize', restart);
        window.removeEventListener('pageshow', restart);
        document.removeEventListener('visibilitychange', restart);
      });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(restart);
      restart();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
